<div class="p-grid">
    <div class="p-col-12 page-header">News & Updates</div>
    <div class="p-col-12 divider-header">
        <p-divider></p-divider>
    </div>
    <div class="p-col-12 p-lg-9">
        <div class="p-grid">
            <div class="p-col-12">
                <div class="card">
                    <div id="dataListWrapper">
                        <p-dataView #dv [value]="news" [paginator]="true" [rows]="10" filterBy="HeadLine,BroadcastBody,PostingUserName,PubDate"
                                    [showCurrentPageReport]="true"
                                    [rowsPerPageOptions]="rowsPerPageOptions"
                                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
                            <ng-template pTemplate="header">
                                <div class="p-grid">
                                    <div class="p-col-12 p-lg-3 p-md-3" *ngIf="canAddNews">
                                        <p-button styleClass="fullwidthbtn" label="Add News" routerLink="news/add"></p-button>
                                    </div>
                                    <div class="p-col-12 p-lg-9 p-md-9">
                                        <input type="search" pInputText placeholder="Search News" (input)="dv.filter($event.target.value)">
                                    </div>
                                </div>
                            </ng-template>
                            <ng-template let-news pTemplate="listItem">
                                <div class="p-col-12">
                                    <div class="product-list-item">
                                        <img [src]="'assets/layout/images/naiimages/news-' + news.NewsMessageTypeID + '.jpg' " />
                                        <div class="product-list-detail">
                                            <div class="product-type">NAI Global</div>
                                            <div class="product-name">{{news.HeadLine}}</div>
                                            <div class="product-description" innerHTML="{{removeHTML(news.BroadcastBody) | slice:0:500}}"></div>
                                            <!--<p-button routerLink="/news/{{news.Id}}" class="p-button-text" label="Read More"></p-button>-->
                                            <a routerLink="/news/{{news.Id}}"><span [class]="'object-badge status-red'">READ MORE</span></a>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </p-dataView>
                    </div>
                    <div>
                        <p-carousel [value]="sponsors" styleClass="custom-carousel" [numVisible]="4" [numScroll]="1" [circular]="true" [autoplayInterval]="5000" [responsiveOptions]="responsiveOptions">
                            <ng-template let-sponsor pTemplate="item">
                                <div class="product-item">
                                    <div class="product-item-content">
                                        <!-- <div>
                                            <span [class]="'product-badge status-'+sponsor.ResourceCategoryID">{{getStatusbadge(sponsor.ResourceCategoryID)}}</span>
                                        </div> -->
                                        <div class="p-md-3">
                                            <img src={{getImageURL(sponsor)}} class="product-image" />
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </p-carousel>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="p-col-12 p-lg-3">
        <div class="card">
            <div class="p-col-12" *ngIf="advertisements!= null && advertisements.length > 0">
                <a href={{getBrandAdvertUrl(0)}} target="_blank"><img src={{getBrandAdvertImage(0)}} style="width: 100% !important; border:solid;  border-width: 1px;" /></a>
            </div>
            <div class="p-col-12" *ngIf="advertisements!= null && advertisements.length > 1">
                <a href={{getBrandAdvertUrl(1)}} target="_blank"><img src={{getBrandAdvertImage(1)}} style="width: 100% !important; border:solid;  border-width: 1px;" /></a>
            </div>
            <div class="p-col-12" *ngIf="advertisements!= null && advertisements.length > 2">
                <a href={{getBrandAdvertUrl(2)}} target="_blank"><img src={{getBrandAdvertImage(2)}} style="width: 100% !important; border:solid;  border-width: 1px;" /></a>
            </div>
            <div class="p-col-12" *ngIf="advertisements!= null && advertisements.length > 3">
                <a href={{getBrandAdvertUrl(3)}} target="_blank"><img src={{getBrandAdvertImage(3)}} style="width: 100% !important; border:solid;  border-width: 1px;" /></a>
            </div>
            <div class="p-col-12" *ngIf="advertisements!= null && advertisements.length > 4">
                <a href={{getBrandAdvertUrl(4)}} target="_blank"><img src={{getBrandAdvertImage(4)}} style="width: 100% !important; border:solid;  border-width: 1px;" /></a>
            </div>
            <div class="p-col-12" *ngIf="advertisements!= null && advertisements.length > 5">
                <a href={{getBrandAdvertUrl(5)}} target="_blank"><img src={{getBrandAdvertImage(5)}} style="width: 100% !important; border:solid;  border-width: 1px;" /></a>
            </div>
        </div>
    </div>
</div>
